export default "__VITE_ASSET__ce209d06__"